import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import TextareaAutosize from 'react-autosize-textarea';
import { ReactComponent as SendIcon } from 'assets/icons/send.svg';

const SendMessage = ({ className, handleSendMessage, loading, isStarted, isSending }) => {
  const [message, setMessage] = useState('');
  const isInactive = !isStarted || loading || isSending;

  const handleClickSend = useCallback(() => {
    if (isInactive) return;

    handleSendMessage(message);
    setMessage('');
  }, [message, handleSendMessage, isInactive]);

  const handleEnterKey = useCallback(
    (e) => {
      if (e.keyCode === 13 && e.shiftKey === false) {
        e.preventDefault();
        handleClickSend();
      }
    },
    [handleClickSend]
  );

  const handleTextChange = useCallback((event) => {
    if (!event.target) return;

    setMessage(event.target.value);
  }, []);

  return (
    <div className={className}>
      <TextareaAutosize
        data-testid="sendmessage-textarea"
        placeholder="Write message"
        rows={2}
        value={message}
        onChange={handleTextChange}
        onKeyDown={handleEnterKey}
        disabled={!isStarted}
      />
      <button
        data-testid="sendmessage-button"
        className={cx('send-button', { inactive: isInactive })}
        onClick={handleClickSend}
        disabled={isInactive}
      >
        <SendIcon />
      </button>
    </div>
  );
};

export default SendMessage;
